import { createUseQuery } from 'api/common/createUseQuery'
import { Company, fetchCompanies } from 'api/fetchers/filters/fetchCompanies'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useCompanies = createUseQuery({
  queryKey: ApiQueryKeys.COMPANIES,
  fetcher: fetchCompanies,
  selector: res => (res?.data as Company[] | undefined) ?? ([] as Company[]),
})
